<div class="query-chart">
  <div class="chart-titop" *ngIf="!routing.isFolio()">
    <app-news-title *ngIf="titolo$|async as titolo" [titolo]="titolo"></app-news-title>
  </div>
  <div class="chart" *ngIf="!loading" [chart]="stockChart"></div>
  <div class="loading" *ngIf="loading">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
</div>
